import gql from 'graphql-tag'

export const adminBillingDevices = gql`
  query AdminBillingDevices(
    $search: String
    $status: String
    $billingEnabled: Boolean
    $activationState: String
    $companyId: ID
    $simStatus: String
    $deviceType: String
    $mobileConnection: Boolean
    $inOperation: Boolean
    $mobileNotConfEventCountGt: Int
    $mobileNotConfEventCountLt: Int
    $page: Int
    $limit: Int
  ) {
    adminBillingDevices(
      search: $search
      status: $status
      billingEnabled: $billingEnabled
      activationState: $activationState
      companyId: $companyId
      simStatus: $simStatus
      deviceType: $deviceType
      mobileConnection: $mobileConnection
      inOperation: $inOperation
      mobileNotConfEventCountGt: $mobileNotConfEventCountGt
      mobileNotConfEventCountLt: $mobileNotConfEventCountLt
      page: $page
      limit: $limit
    ) {
      devices {
        id
        customName
        controller
        companyId
        companyName
        status
        daysRemaining
        validFrom
        validTo
        subscriptionId
        subscriptionKeyId
        inOperationSince
        userCount
        deviceBillingEnabled
        simStatus
        activationState
        connectionType
      }
      totalCount
      page
      totalPages
    }
  }
`
